import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
//
import LoadingLogo from './LoadingLogo';
import ProgressBar from '../components/ProgressBar';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  right: 0,
  bottom: 0,
  zIndex: 99999,
  width: '100%',
  height: '100%',
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

LoadingLogoScreen.propTypes = {
  isDashboard: PropTypes.bool,
};

export default function LoadingLogoScreen({ isDashboard, ...other }) {
  return (
    <>
      <ProgressBar />

      {!isDashboard && (
        <RootStyle {...other}>
          <LoadingLogo />
        </RootStyle>
      )}
    </>
  );
}
